<template>
  <div class="producto-view">
    <div class="back-link">
      <router-link to="/">← Volver al dashboard</router-link>
    </div>
    <ComparadorProducto
      :codigo="codigo"
      :initial-vista="vista"
    />
  </div>
</template>

<script>
import ComparadorProducto from '@/components/ComparadorProducto.vue'

export default {
  name: 'ProductoView',
  components: { ComparadorProducto },
  computed: {
    codigo() {
      return this.$route.params.codigo || null
    },
    vista() {
      return this.$route.query.vista || 'web'
    },
  },
}
</script>

<style scoped>
.producto-view {
  min-height: 100vh;
  background: #f5f7fa;
  padding: 16px 0;
}
.back-link {
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 24px 12px;
}
.back-link a {
  color: #1f4e78;
  text-decoration: none;
  font-size: 13px;
}
.back-link a:hover { text-decoration: underline; }
</style>
